import React from 'react'
import { GameMapChromeContext, IDENTITY_MAP_FIT, PortraitMapFitContext, type PortraitMapFit } from '../../hooks/useGameMapChrome'

/** Live measurements survive replacing the live board with a snapshot. */
export function MapChromeProvider({ height, children }: { height: number; children: React.ReactNode }) {
  const [fit, setFit] = React.useState(IDENTITY_MAP_FIT)
  const recordFit = React.useCallback((next: PortraitMapFit) => {
    setFit(current => current.mapId === next.mapId && current.scale === next.scale &&
      current.shift === next.shift && current.tipsHeight === next.tipsHeight ? current : next)
  }, [])
  const value = React.useMemo(() => ({ fit, recordFit }), [fit, recordFit])
  return <GameMapChromeContext.Provider value={height}>
    <PortraitMapFitContext.Provider value={value}>{children}</PortraitMapFitContext.Provider>
  </GameMapChromeContext.Provider>
}
